import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { ClassroomStudentActivityState, trimString } from "js/components/RegularClassroomUser/utils";
import { Flex, Image, Text } from "@chakra-ui/react";
import IconTileContentLayout from "js/components/StudentTile/components/IconTileContentLayout";
import ScreenshotContainer from "js/components/StudentTile/components/activeScreenStates/ScreenshotContainer";
import { getCopy, getIcon } from "js/utils/screens/contextBasedScreenUtils";
import { restrictedScreenshotImage } from "js/components/StudentTile/components/activeScreenStates/restrictedScreenshot";

interface ContextBasedStudentTileProps {
	url: string;
	state: ClassroomStudentActivityState | undefined;
	title: string;
	onClick: () => void;
	clickable: boolean;
}

export const ContextBasedStudentTile: React.FC<ContextBasedStudentTileProps> = ({
	url,
	state,
	title,
	onClick,
	clickable,
}: ContextBasedStudentTileProps) => {
	const { t } = useTranslation();
	const copyKey = useMemo(() => getCopy(url, state), [url, state]);
	const copy = copyKey ? t(copyKey) : undefined;
	const icon = useMemo(() => getIcon(url, state), [url, state]);

	if (state === ClassroomStudentActivityState.SCREEN_CAPTURE_RESTRICTED) {
		return (
			<ScreenshotContainer clickable={false}>
				<img className="RegularClassroomUser_screenshotImage" alt={trimString(title, 40)} src={restrictedScreenshotImage} />
			</ScreenshotContainer>
		);
	}

	return (
		<ScreenshotContainer clickable={clickable} onClick={onClick}>
			<Flex flexDirection={"column"} align={"center"} height={"100%"} backgroundColor={"white"}>
				<IconTileContentLayout>
					<Image src={icon} htmlHeight={32} htmlWidth={32} />
					<Text>{copy ?? title}</Text>
				</IconTileContentLayout>
			</Flex>
		</ScreenshotContainer>
	);
};
